export default __webpack_public_path__ + "static/media/develop_instruments_main.08167979.jpg";